var exports = {
  "kL": "xcc377c0b--d4c908--container",
  "YT": "xcc377c0b--d4c908--scalable-container",
  "Qs": "xcc377c0b--d4c908--content",
  "b8": "xcc377c0b--d4c908--builderName",
  "nl": "xcc377c0b--d4c908--deadline",
  "q9": "xcc377c0b--d4c908--price",
  "O3": "xcc377c0b--d4c908--underground",
  "hl": "xcc377c0b--d4c908--address",
  "kB": "xcc377c0b--d4c908--time",
  "DD": "xcc377c0b--d4c908--title",
  "Sl": "xcc377c0b--d4c908--image",
  "NE": "xcc377c0b--d4c908--undergroundColor",
  "wm": "xcc377c0b--d4c908--time-icon",
  "gn": "xcc377c0b--d4c908--time-text",
};

module.exports = exports;
